import { HttpParams } from '@angular/common/http';

import { Filter, FilterOperator, FilterType } from '../models/filters.model';

export function createFilterParams(filters: Filter[], initialParams = new HttpParams()): HttpParams {
  let params = initialParams;

  for (const filter of filters) {
    if (filter.type === FilterType.DATE) {
      if (filter.operator === FilterOperator.BETWEEN && filter.valueFrom && filter.valueTo) {
        const from = filter.valueFrom.toISO({ includeOffset: false });
        const to = filter.valueTo.toISO({ includeOffset: false });
        if (from && to) {
          params = params.append(`${filter.filter}_from`, from + 'Z');
          params = params.append(`${filter.filter}_to`, to + 'Z');
        }
      } else if (filter.operator === FilterOperator.AFTER && filter.valueFrom) {
        const from = filter.valueFrom.toISO({ includeOffset: false });
        if (from) {
          params = params.append(`${filter.filter}_from`, from + 'Z');
        }
      } else if (filter.operator === FilterOperator.BEFORE && filter.valueTo) {
        const to = filter.valueTo.toISO({ includeOffset: false });
        if (to) {
          params = params.append(`${filter.filter}_to`, to + 'Z');
        }
      }
    } else {
      const filterValue = filter.value;
      if (filter.operator === FilterOperator.AFTER) {
        params = params.append(`${filter.filter}_from`, filterValue.toString());
      } else if (filter.operator === FilterOperator.BEFORE) {
        params = params.append(`${filter.filter}_to`, filterValue.toString());
      } else {
        params = params.append(filter.filter, filterValue.toString());
      }
    }
  }

  return params;
}
